/* unplugin-vue-components disabled */// extracted by mini-css-extract-plugin
export default {"section":"Terms_section_bP8Fz"};